import { render, staticRenderFns } from "./_cart-buttom.component.vue?vue&type=template&id=77242459&scoped=true"
import script from "./_cart-buttom.component.vue?vue&type=script&lang=js"
export * from "./_cart-buttom.component.vue?vue&type=script&lang=js"
import style0 from "./_cart-buttom.component.vue?vue&type=style&index=0&id=77242459&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77242459",
  null
  
)

export default component.exports